import React from 'react';
import { OauthApplicationsTable } from '../components/OauthApplications';

export default function OauthApplications() {
  return <OauthApplicationsTable />;
}
